import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { inject, Injectable } from "@angular/core";
import { AvatarService } from "src/app/services/avatar.service";
import { MemberLight } from "src/app/backend/models/member/member";
import { getPublicFileSrcById } from "src/app/support/public-file";
import { MemberBootstrapCacheService } from "src/app/services/member-bootstrap-cache.service";

@Injectable()
export class ProvideAvatarGuard {
  private readonly memberBootstrapCache = inject(MemberBootstrapCacheService);
  private readonly avatarService = inject(AvatarService);

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    const members =
      (await this.memberBootstrapCache.loadActiveAllLight()) as Array<
        MemberLight & { user?: { avatar?: string } }
      >;

    for (const member of members) {
      if (member.user?.avatar) {
        const url = <string>getPublicFileSrcById(member.user.avatar, {
          noCache: true
        });

        this.avatarService.register(member.id, url);
      }
    }

    return true;
  }
}
